import useIndicator, { Indicator } from '@shared/hooks/src/useIndicator'

export default function useUnreadConversationsCount() {
  const { data: totalUnreadMessageCount } = useIndicator(Indicator.UnreadConversationsCount, undefined, {
    select: (_) => _.count,
  })

  return totalUnreadMessageCount
}
